import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { EditIcon, Link, RemoveIcon, StyledFlex } from '@dreryk/react-components';

import { PractitionerReceptionServiceUpdateModalOpener } from '../../update/practitioner/PractitionerReceptionServiceUpdateModalOpener';
import { PractitionerReceptionServiceRemoveConfirmationEventInterceptor } from '../remove/PractitionerReceptionServiceRemoveConfirmationEventInterceptor';

import { PractitionerReceptionServiceRemoveAction } from './PractitionerReceptionServiceOptionsCell.actions';

type PractitionerReceptionServiceUpdateLinkProps = {
   readonly receptionServiceId: ReceptionServiceId;
   readonly practitionerId: number;
};

export const PractitionerReceptionServiceUpdateLink = (
   props: PractitionerReceptionServiceUpdateLinkProps
): JSX.Element => {
   return (
      <PractitionerReceptionServiceUpdateModalOpener
         receptionServiceId={props.receptionServiceId}
         practitionerId={props.practitionerId}
      >
         {({ openModal }) => (
            <Link testId={'practitionerReceptionServiceUpdate'} icon={<EditIcon />} onClick={openModal} />
         )}
      </PractitionerReceptionServiceUpdateModalOpener>
   );
};

type PractitionerReceptionServiceRemoveLink = {
   readonly receptionServiceName: string;
   readonly practitionerReceptionServiceId: number;
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
};

export const PractitionerReceptionServiceRemoveLink = (props: PractitionerReceptionServiceRemoveLink): JSX.Element => {
   return (
      <PractitionerReceptionServiceRemoveConfirmationEventInterceptor
         receptionServiceName={props.receptionServiceName}
         practitionerName={props.practitionerName}
         hasMorePractitioners={props.hasMorePractitioners}
      >
         <PractitionerReceptionServiceRemoveAction id={props.practitionerReceptionServiceId}>
            {({ removePractitioner }) => (
               <Link testId={'practitionerReceptionServiceRemove'} onClick={removePractitioner} icon={<RemoveIcon />} />
            )}
         </PractitionerReceptionServiceRemoveAction>
      </PractitionerReceptionServiceRemoveConfirmationEventInterceptor>
   );
};

type PractitionerReceptionServiceOptionsCellProps = {
   readonly receptionServiceId: ReceptionServiceId;
   readonly receptionServiceName: string;
   readonly practitionerReceptionServiceId: number;
   readonly practitionerId: number;
   readonly practitionerName: string;
   readonly hasMorePractitioners: boolean;
};

export const PractitionerReceptionServiceOptionsCell = (
   props: PractitionerReceptionServiceOptionsCellProps
): JSX.Element => {
   return (
      <StyledFlex>
         <PractitionerReceptionServiceUpdateLink
            receptionServiceId={props.receptionServiceId}
            practitionerId={props.practitionerId}
         />
         <PractitionerReceptionServiceRemoveLink
            receptionServiceName={props.receptionServiceName}
            practitionerName={props.practitionerName}
            practitionerReceptionServiceId={props.practitionerReceptionServiceId}
            hasMorePractitioners={props.hasMorePractitioners}
         />
      </StyledFlex>
   );
};
